
@if (impl.searchResultsList?.length > 0 || impl.semanticSearchResultsList?.length > 0  || universalService.foldersArray.length > 0) {
<div class="message-box" (click)="showSearchStatusDetails()">
    <span class="Neueinfo"></span>
    <span class="message-box-txt">See what's searchable?</span>
</div>
}